import React from 'react'

const IconeStackedBooks: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    {...props}
    fill="#000000"
    height="800px"
    width="800px"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 392.673 392.673"
    xmlSpace="preserve"
  >
    <path
      d="M387.673,308.613H368.54c-11.529-27.481-11.529-60.675,0-88.156h19.133c2.761,0,5-2.239,5-5s-2.239-5-5-5h-31.873
c10.207-21.992,9.318-47.504-2.684-68.877c11.093-20.44,10.554-45.097-1.635-65.12c-0.907-1.491-2.526-2.4-4.271-2.4h-34.408
c-2.761,0-5,2.239-5,5s2.239,5,5,5h31.519c8.967,16.51,8.968,36.272,0,52.781h-110.8c5.355-12.117,6.926-25.601,4.39-38.767
c-0.522-2.711-3.143-4.488-5.855-3.964c-2.712,0.522-4.486,3.144-3.964,5.855c2.435,12.638,0.408,25.624-5.697,36.875h-15.251
c7.461-16.837,7.461-35.943,0-52.78h15.239c0.626,1.154,1.224,2.323,1.763,3.511c0.837,1.844,2.654,2.934,4.556,2.934
c0.691,0,1.394-0.145,2.064-0.449c2.31-1.049,3.414-3.633,2.696-5.997H296.8c2.761,0,5-2.239,5-5s-2.239-5-5-5l-241.655,0
c-2.761,0-5,2.239-5,5s2.239,5,5,5h16.208c8.97,16.511,8.97,36.27,0,52.781H5c-2.761,0-5,2.239-5,5s2.239,5,5,5h19.521
c10.987,19.858,10.987,43.759,0,63.617H5c-2.761,0-5,2.239-5,5s2.239,5,5,5h33.073c-11.918,30.233-10.891,66.054,3.104,95.313
c0.831,1.737,2.585,2.843,4.511,2.843h341.985c2.761,0,5-2.239,5-5S390.435,308.613,387.673,308.613z M353.103,236.063h-17.361
c-2.761,0-5,2.239-5,5s2.239,5,5,5h15.505c-0.677,4.692-1.095,9.431-1.252,14.183h-55.863c-2.761,0-5,2.239-5,5s2.239,5,5,5h55.917
c0.209,4.755,0.671,9.496,1.402,14.184h-31.713c-2.761,0-5,2.239-5,5s2.239,5,5,5h33.693c1.162,4.83,2.618,9.571,4.356,14.183
H239.444c-1.924-4.586-3.528-9.331-4.81-14.183h69.635c2.761,0,5-2.239,5-5s-2.239-5-5-5h-71.792
c-0.797-4.681-1.315-9.423-1.542-14.184h43.46c2.761,0,5-2.239,5-5s-2.239-5-5-5h-43.514c0.171-4.756,0.619-9.498,1.357-14.183
h89.101c2.761,0,5-2.239,5-5s-2.239-5-5-5h-87.062c1.338-5.346,3.056-10.573,5.167-15.606h118.344
C355.879,225.522,354.317,230.742,353.103,236.063z M222.371,308.613c-7.545-18.016-10.246-38.991-7.607-59.447
c0.353-2.739-1.581-5.246-4.319-5.599c-2.739-0.35-5.245,1.581-5.599,4.319c-2.675,20.74-0.26,42.008,6.781,60.727h-20.194
c-11.529-27.481-11.529-60.675,0-88.156h20.212c-1.503,3.992-2.826,8.099-3.905,12.31c-0.686,2.675,0.927,5.399,3.602,6.085
c0.417,0.107,0.834,0.158,1.245,0.158c2.229,0,4.261-1.501,4.84-3.759c1.31-5.11,2.97-10.072,4.946-14.793h6.32
c-10.483,27.805-10.483,60.351,0,88.156H222.371z M164.824,146.841h5.87c10.985,19.856,10.985,43.76,0,63.617h-5.87
C174.207,190.242,174.207,167.056,164.824,146.841z M192.586,84.06h3.428c8.966,16.508,8.966,36.272,0,52.781h-3.428
C200.047,120.003,200.047,100.898,192.586,84.06z M181.894,146.841h19.733c10.987,19.858,10.987,43.759,0,63.617h-19.733
C191.277,190.242,191.277,167.056,181.894,146.841z M344.601,146.841c10.985,19.856,10.985,43.76,0,63.617H212.835
c9.383-20.215,9.383-43.401,0-63.617h12.443c0.002,0,0.005,0,0.007,0C225.287,146.841,344.601,146.841,344.601,146.841z
 M86.526,124.598H151.7c2.761,0,5-2.239,5-5s-2.239-5-5-5H87.958c0.208-3.243,0.166-6.496-0.114-9.735h38.25c2.761,0,5-2.239,5-5
s-2.239-5-5-5H86.193c-0.907-3.673-2.143-7.286-3.7-10.802h98.955c1.889,3.477,3.38,7.097,4.473,10.802h-42.755
c-2.761,0-5,2.239-5,5s2.239,5,5,5h44.732c0.33,3.236,0.368,6.494,0.123,9.735h-14.982c-2.761,0-5,2.239-5,5s2.239,5,5,5h13.287
c-1.119,4.207-2.745,8.317-4.878,12.243H82.492C84.253,132.866,85.596,128.766,86.526,124.598z M153.617,146.841
c1.465,2.647,2.736,5.366,3.81,8.138H38.948c-0.911-2.755-1.983-5.472-3.22-8.138H153.617z M39.301,201.253h19.045
c2.761,0,5-2.239,5-5s-2.239-5-5-5H41.709c0.458-2.698,0.762-5.415,0.923-8.138h79.195c2.761,0,5-2.239,5-5s-2.239-5-5-5H42.563
c-0.201-2.725-0.554-5.44-1.052-8.137h118.9c0.575,2.691,0.975,5.409,1.207,8.137h-23.256c-2.761,0-5,2.239-5,5s2.239,5,5,5h23.347
c-0.187,2.727-0.552,5.444-1.081,8.138H76.483c-2.761,0-5,2.239-5,5s2.239,5,5,5h81.342c-1.155,3.141-2.556,6.218-4.208,9.204
H35.728C37.125,207.448,38.32,204.375,39.301,201.253z M48.893,220.458h4.831c-3.189,8.464-5.446,17.445-6.699,26.81
c-0.367,2.737,1.555,5.253,4.292,5.619c0.225,0.03,0.449,0.045,0.67,0.045c2.466,0,4.613-1.825,4.949-4.337
c1.33-9.93,3.872-19.375,7.546-28.137h116.2c-10.483,27.805-10.483,60.351,0,88.156H64.475c-5.239-12.518-8.193-26.621-8.558-41.005
c-0.07-2.76-2.359-4.923-5.125-4.872c-2.761,0.07-4.941,2.365-4.872,5.125c0.36,14.159,3.046,28.093,7.804,40.751h-4.83
C36.79,281.139,36.79,247.932,48.893,220.458z"
    />
  </svg>
)

export default IconeStackedBooks
